import { useState, useCallback } from 'react';
import { toast } from 'sonner';
import { adminAPI } from '../../../api/bookings';

export function useReleaseBooking() {
  const [refInput, setRefInput] = useState('');
  const [booking, setBooking] = useState(null);
  const [searching, setSearching] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [releasing, setReleasing] = useState(false);

  const handleSearch = useCallback(async (e) => {
    e.preventDefault();
    const ref = refInput.trim();
    if (!ref) return;
    setSearching(true);
    setSearchError(null);
    setBooking(null);
    try {
      const result = await adminAPI.searchBookingForRelease(ref);
      setBooking(result);
    } catch (err) {
      setSearchError(err.response?.data?.detail || 'No booking found for that reference');
    } finally {
      setSearching(false);
    }
  }, [refInput]);

  const handleConfirmRelease = useCallback(async (reason = '') => {
    if (!booking) return;
    setReleasing(true);
    try {
      const result = await adminAPI.releasePaidBooking(booking.id, reason);
      setBooking({
        ...booking,
        ...result.booking,
        release_eligibility: { eligible: false, locked: false, reason: 'Already released.' },
      });
      setConfirmOpen(false);
      toast.success('Booking released — slot is now free and the customer has been notified.');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to release booking');
    } finally {
      setReleasing(false);
    }
  }, [booking]);

  return {
    refInput, setRefInput, booking, searching, searchError,
    confirmOpen, setConfirmOpen, releasing,
    handleSearch, handleConfirmRelease,
  };
}
